export default __webpack_public_path__ + "static/media/tokenMock.71eda740.svg";